import React from 'react'
import './style.css'

const LifeAtBitsclanOurValue = () => {

    const valuesData = [
        {
            id: 1,
            title: "Innovation with Purpose",
            text: "We believe technology should create real impact. Every line of code, AI model, & cloud solution we build is designed to solve business challenges & fuel growth.",
            className: "innovation-with-purpose",
        },
        {
            id: 2,
            title: "Excellence as Standard",
            text: "From enterprise software to mobile apps, we set the bar high. Our teams deliver quality-driven solutions that are secure, scalable, & built to last.",
            className: "excellence-as-standard",
        },
        {
            id: 3,
            title: "Client-Centric Collaboration",
            text: "Our success comes from yours. We work hand-in-hand with clients, understanding their vision & translating it into technology that accelerates results.",
            className: "client-centric-collaboration",
        },
        {
            id: 4,
            title: "Integrity in Every Step",
            text: "Trust is the foundation of our relationships. We commit to transparency, accountability, & delivering what we promise every single time.",
            className: "integrity-in-every-step p-4 h-100",
        },
        {
            id: 5,
            title: "Continuous Learning & Growth",
            text: "The digital world evolves fast, & so do we. Our people are encouraged to experiment, learn, & adapt ensuring clients always get future-ready solutions.",
            className: "continuous-learning p-4 h-100",
        },
        {
            id: 6,
            title: "People First, Always",
            text: "Behind every innovation is a team of passionate individuals. We value diversity, creativity, & teamwork, fostering an environment where talent thrives.",
            className: "people-first p-4 h-100",
        },
    ];


    return (
        <>
            <section className="life-at-bitsclan-our-value">
                <div className="container">
                    <div className="row mb-xl-5 mb-lg--5 mb-md-3">
                        <div className="col-lg-12">
                            <h2 className="values-heading">Our Values</h2>
                            <p className="values-intro">At Bitsclan IT Solutions, our values define who we are & how we work. They shape every project, every partnership, & every solution we deliver ensuring that we remain a trusted technology partner for businesses worldwide.</p>
                        </div>
                    </div>

                    <div className="row g-4">
                        {valuesData.map((value) => (
                            <div key={value.id} className="col-md-6 col-lg-4">
                                <div className={`value-card ${value.className}`}>
                                    <h3 className="value-title">{value.title}</h3>
                                    <p className="value-text">{value.text}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </>
    )
}

export default LifeAtBitsclanOurValue